import { RATGEBER_A } from "@/data/ratgeber_a";
import { RATGEBER_B } from "@/data/ratgeber_b";

export const RATGEBER = [...RATGEBER_A, ...RATGEBER_B];
